import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { Bridge } from "../_";
import { useLocalStorageState } from 'ahooks';
import { Tabs } from 'antd';
import React, { useEffect } from 'react';
import { useStyles } from "./Jumper.style";
export var SuperPageContainerJumper = function SuperPageContainerJumper() {
  var _Bridge$useLocation = Bridge.useLocation(),
    pathname = _Bridge$useLocation.pathname;
  var _useLocalStorageState = useLocalStorageState("JiShuXin['SuperPageContainerJumper']", {
      defaultValue: [],
      listenStorageChange: true
    }),
    _useLocalStorageState2 = _slicedToArray(_useLocalStorageState, 2),
    pathnameHistories = _useLocalStorageState2[0],
    setPathnameHistories = _useLocalStorageState2[1];
  var _useStyles = useStyles(),
    styles = _useStyles.styles;
  useEffect(function () {
    if (!pathnameHistories.some(function (pathnameHistory) {
      return pathnameHistory.key === pathname;
    })) {
      setPathnameHistories([].concat(_toConsumableArray(pathnameHistories), [{
        label: document.title,
        key: pathname
      }]));
    }
  }, [pathname]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement(Tabs, {
    activeKey: pathname,
    onChange: function onChange(activeKey) {
      return Bridge.history.push(activeKey);
    },
    type: "editable-card",
    size: "small",
    onEdit: function onEdit(pathnameHistoryKey) {
      return setPathnameHistories(pathnameHistories.filter(function (pathnameHistory) {
        return pathnameHistory.key !== pathnameHistoryKey;
      }));
    },
    hideAdd: true,
    items: pathnameHistories
  }));
};